import { QueryClientProvider } from '@tanstack/react-query'

import { getQueryClient } from '@/modules/Infrastructure'

import { ProductAttributeProvider, useProductAttributes } from '../../state'
import { AdditionalInfo } from './ProductDetails/AdditionalInfo'
import { Description } from './ProductDetails/Description'
import { AutoRelated } from './Related/AutoRelated'
import { CrossSellProducts } from './Related/CrossSellProducts'
import { RelatedProducts } from './Related/RelatedProducts'
import { UpsellProducts } from './Related/UpsellProducts'
import { CheckoutProvider } from '../../../Checkout'
import { ReviewsProvider, ReviewList, ReviewForm } from '../../../Reviews'
import { UiProvider } from '../../../Theme'
import { WishlistProvider } from '../../../Wishlist'
import { getProductViewConfig } from '../../lib/productViewConfig'

const queryClient = getQueryClient()

function DisclaimerText() {
  return (
    <p className="font-main-font text-sm xl:text-lg text-text-color mt-3 p-3 xl:p-5">
      Tools.store.ro face eforturi permanente pentru a pastra acuratetea informatiilor din acestă
      pagina. Rareori, acestea pot contine inadvertente. Fotografiile au caracter informativ si pot
      contine accesorii neincluse în pachetele standard, iar unele specificatii pot fi modificate de
      catre producator fara preaviz sau pot contine erori de operare. Toate promotiile prezente in
      site sunt valabile in limita stocului.
    </p>
  )
}

export function ProductDetails() {
  const { productSku } = getProductViewConfig()

  return (
    <QueryClientProvider client={queryClient}>
      <UiProvider>
        <CheckoutProvider>
          <WishlistProvider>
            <ProductAttributeProvider productSku={productSku}>
              <div>
                <div>
                  <UpsellProducts />
                  <Description />
                  <AdditionalInfo />
                  <AutoRelated />
                  <RelatedProducts />
                  <CrossSellProducts />
                  <ReviewsProvider productSku={productSku}>
                    <ReviewList />
                    <ReviewFormWrapper />
                  </ReviewsProvider>
                </div>
                <DisclaimerText />
              </div>
            </ProductAttributeProvider>
          </WishlistProvider>
        </CheckoutProvider>
      </UiProvider>
    </QueryClientProvider>
  )
}

function ReviewFormWrapper() {
  const { productSku } = getProductViewConfig()
  const { productName } = useProductAttributes()
  return <ReviewForm productSku={productSku} productName={productName ?? ''} />
}
